import React from 'react'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useUserAuth } from '../context/UserAuthContext';

const Signup = () => {

  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [error,setError]  = useState("");
  const {signUp} = useUserAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) =>
  {
      e.preventDefault();
      setError("");
      try{
        await signUp(email,password)
        navigate('/')
      } catch(err)
      {
          setError(err.message);
          alert(error);
      }
  }

  return (
<div className='w-full h-screen flex items-center justify-center'>
      <div className='sm:w-[420px] sm:h-[520px] w-[320px] h-[440px] shadow-lg flex flex-col items-center justify-center sm:py-8 p-12  bg-white'>
          <div>
            <form className='' onSubmit={handleSubmit}>
              <p className='text-2xl font-bold mb-10'>Create Account For Free!</p>
              <div className='flex flex-col mb-3'>
                <label className='  font-medium'>Email</label>
                <input type="email" placeholder='Enter the email' className='border-2 border-slate-300 px-4 py-2 outline-none sm:w-[320px] w-auto' onChange={(e) => { setEmail(e.target.value) }} required/>
              </div>
              <div className='flex flex-col mb-3'>
                <label className='  font-medium'>Password</label>
                <input type="password" placeholder='Enter the password' className='border-2 border-slate-300 px-4 py-2 outline-none' onChange={(e) => { setPassword(e.target.value) }} required/>
              </div>
              <button type='submit' className='border-2 border-black bg-black text-white px-4 py-2 mb-3 mt-4 sm:w-[320px] w-[260px] font-medium'>Sign up</button>
            </form>
          </div>
          <div className=''>
            <p className='font-medium'>Already have an account? <Link to='/' className='font-bold underline'>Login</Link> </p>
          </div>
      </div>
    </div>
  )
}

export default Signup